"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var component_wbr_string_1 = __importDefault(require("@rotaryintl/component-wbr-string"));

var component_icon_font_1 = __importDefault(require("@rotaryintl/component-icon-font"));

require("./styles.css");

var FooterV2 = function (props) {
  var _a, _b, _c;

  var copyrightText = props.copyrightText.replace('{year}', new Date().getFullYear().toString());
  return (0, jsx_runtime_1.jsxs)("footer", __assign({
    className: "rwc-footer-v2"
  }, {
    children: [(0, jsx_runtime_1.jsxs)("div", __assign({
      className: "footer-container"
    }, {
      children: [(0, jsx_runtime_1.jsxs)("div", __assign({
        className: "footer-icons"
      }, {
        children: [(0, jsx_runtime_1.jsx)("div", __assign({
          className: "footer-icons__logo"
        }, {
          children: (0, jsx_runtime_1.jsxs)("a", __assign({
            href: props.logoLink.linkUrl,
            target: props.logoLink.linkTarget
          }, {
            children: [props.logoImage, (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
              tag: "h6"
            }, {
              children: props.logoText
            }))]
          }))
        })), (0, jsx_runtime_1.jsx)("div", __assign({
          className: "footer-icons__social"
        }, {
          children: (0, jsx_runtime_1.jsx)("ul", {
            children: (_a = props.socialLinks) === null || _a === void 0 ? void 0 : _a.map(function (socialLink) {
              return (0, jsx_runtime_1.jsx)("li", {
                children: (0, jsx_runtime_1.jsx)("a", __assign({
                  href: socialLink.link.linkUrl,
                  target: socialLink.link.linkTarget
                }, {
                  children: (0, jsx_runtime_1.jsx)("img", {
                    src: socialLink.image.imageUrl,
                    alt: socialLink.image.imageAlt
                  })
                }))
              }, "footer-icon-".concat(socialLink.image.imageUrl, "-").concat(socialLink.link.linkUrl));
            })
          })
        }))]
      })), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "footer-links"
      }, {
        children: (0, jsx_runtime_1.jsx)("ul", {
          children: (_b = props.footerLinks) === null || _b === void 0 ? void 0 : _b.map(function (link) {
            return (0, jsx_runtime_1.jsx)("li", {
              children: (0, jsx_runtime_1.jsx)("a", __assign({
                href: link.linkUrl,
                target: link.linkTarget
              }, {
                children: (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
                  tag: "span"
                }, {
                  children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
                    children: [link.linkText, link.external && (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
                      type: "fas-external-link",
                      color: "#ffffff",
                      style: {
                        width: 12,
                        height: 12
                      }
                    })]
                  })
                }))
              }))
            }, "footer-link-".concat(link.linkText, "-").concat(link.linkUrl));
          })
        })
      }))]
    })), (0, jsx_runtime_1.jsx)("div", __assign({
      className: "footer-utility"
    }, {
      children: (0, jsx_runtime_1.jsxs)("div", __assign({
        className: "footer-utility__content"
      }, {
        children: [(0, jsx_runtime_1.jsx)("span", __assign({
          className: "footer-utility__copyright"
        }, {
          children: copyrightText
        })), (0, jsx_runtime_1.jsx)("ul", __assign({
          className: "footer-utility__utility-links"
        }, {
          children: (_c = props.utilityLinks) === null || _c === void 0 ? void 0 : _c.map(function (link) {
            return (0, jsx_runtime_1.jsx)("li", {
              children: (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
                tag: "a",
                href: link.linkUrl,
                target: link.linkTarget
              }, {
                children: link.linkText
              }))
            }, "footer-utility-link-".concat(link.linkText, "-").concat(link.linkUrl));
          })
        }))]
      }))
    }))]
  }));
};

exports.default = FooterV2;